import * as Modules from 'components/modules';
import T from 'prop-types';
import React from 'react';
import { backgroundImageType } from 'types';
import * as s from './styled';

const TextImageSection = ({
  title,
  subtitle,
  description,
  colors,
  height,
  textAlign,
  textHorizAlign,
  backgroundImage: {
    mobile: backgroundImageMobile,
    desktop: backgroundImageDesktop,
  },
}) => {
  const textHorizAlignChecked = textHorizAlign === '' ? 'left' : textHorizAlign;
  return (
    <s.Section height={height} textHorizAlign={textHorizAlignChecked}>
      <s.Overlay backgroundColor={colors.background} />
      <s.BackgroundImageOverlay
        backgroundColor={colors.background}
        backgroundImageDesktop={backgroundImageDesktop}
        backgroundImageMobile={backgroundImageMobile}
      />
      {(title || subtitle || description[0]) && (
        <s.TextWrapper
          textAlign={textAlign}
          mobileBackgroundColor={colors.mobileBackground}
        >
          <s.TextContainer textHorizAlign={textHorizAlignChecked}>
            <Modules.TextBlock1
              title={title}
              subtitle={subtitle}
              description={description}
              colors={colors}
            />
          </s.TextContainer>
        </s.TextWrapper>
      )}
    </s.Section>
  );
};

TextImageSection.defaultProps = {
  height: null,
  textAlign: 'flex-start',
  textHorizAlign: 'left',
  backgroundImage: {
    desktop: {
      src: false,
      backgroundRepeat: false,
      backgroundPosition: false,
      backgroundSize: false,
      backgroundOpacity: false,
    },
    mobile: {
      src: false,
      backgroundRepeat: false,
      backgroundPosition: false,
      backgroundSize: false,
      backgroundOpacity: false,
    },
  },
};
TextImageSection.propTypes = {
  textAlign: T.string,
  textHorizAlign: T.string,
  title: T.string.isRequired,
  subtitle: T.string.isRequired,
  description: T.arrayOf(T.string),
  backgroundImage: T.shape({
    desktop: backgroundImageType,
    mobile: backgroundImageType,
  }),
  colors: T.shape({
    background: T.string,
    mobileBackground: T.string,
    title: T.string,
    subtitle: T.string,
    description: T.string,
  }).isRequired,
  height: T.string,
};

export default TextImageSection;



// WEBPACK FOOTER //
// ./src/components/modules/TextImageSection/TextImageSection.js